import src from "IMAGE";
export default { src, width: 1104, height: 544, blurWidth: 0, blurHeight: 0};
